import React from 'react';
import { Route } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import NavTabs from '../../../shared/components/NavTabs';
import Alarm from './Alarm';
import AlarmPolicy from './AlarmPolicy';
import NotificationChannels from './NotificationChannels';

const useStyles = makeStyles({
  alarmPolicyTabs: {
    width: '175px !important',
  },
  noificationChannelsTab: {
    width: '300px !important',
  },
});

interface AlarmTabsProps {
  basePath: string;
}

const AlarmTabs: React.FC<AlarmTabsProps> = ({ basePath }: AlarmTabsProps) => {
  const classes = useStyles();
  return (
    <NavTabs
      tabs={[
        { label: 'Alarm', value: '', to: '/', className: classes.alarmPolicyTabs },
        { label: 'Alarm Policy', value: 'policy', to: '/policy', className: classes.alarmPolicyTabs },
        {
          label: 'Notification Channels',
          value: 'notifChannels',
          to: '/notifChannels',
          className: classes.noificationChannelsTab,
        },
      ]}
      basePath={basePath}
    >
      <Route exact path="/">
        <Alarm />
      </Route>
      <Route exact path="/policy">
        <AlarmPolicy />
      </Route>
      <Route exact path="/notifChannels">
        <NotificationChannels />
      </Route>
    </NavTabs>
  );
};

export default AlarmTabs;
